// src/data/agents.js
// Shared agent data — imported by both Agents.jsx and PropertyDetails.jsx

const AGENTS = [
  {
    id: 1,
    name: 'Priya Sharma',
    photo: 'https://randomuser.me/api/portraits/women/44.jpg',
    city: 'Mumbai',
    phone: '+91 98765 12001',
    specialty: "Buyer's Agent",
    rating: 4.9,
    reviews: 128,
    listings: 34,
    experience: 9,
    languages: ['Hindi', 'English', 'Marathi'],
    bio: 'Specialises in luxury apartments in South Mumbai and Bandra. Known for transparent dealings and fast closures.',
  },
  {
    id: 2,
    name: 'Arjun Mehta',
    photo: 'https://randomuser.me/api/portraits/men/32.jpg',
    city: 'Pune',
    phone: '+91 98765 12002',
    specialty: "Seller's Agent",
    rating: 4.7,
    reviews: 95,
    listings: 21,
    experience: 6,
    languages: ['Hindi', 'English', 'Marathi'],
    bio: 'Expert in Kothrud and Wakad residential market. Consistently achieves above-asking prices for clients.',
  },
  {
    id: 3,
    name: 'Neha Rao',
    photo: 'https://randomuser.me/api/portraits/women/68.jpg',
    city: 'Bengaluru',
    phone: '+91 98765 12003',
    specialty: 'Rental Agent',
    rating: 4.8,
    reviews: 212,
    listings: 58,
    experience: 11,
    languages: ['Kannada', 'English', 'Hindi'],
    bio: 'Go-to agent for tech professionals relocating to Whitefield and Koramangala. Zero brokerage surprises.',
  },
  {
    id: 4,
    name: 'Ravi Krishnan',
    photo: 'https://randomuser.me/api/portraits/men/71.jpg',
    city: 'Hyderabad',
    phone: '+91 98765 12004',
    specialty: "Buyer's Agent",
    rating: 4.6,
    reviews: 74,
    listings: 19,
    experience: 5,
    languages: ['Telugu', 'Hindi', 'English'],
    bio: 'Deep knowledge of Gachibowli and HITEC City corridors. Helps IT professionals find homes near their workplace.',
  },
  {
    id: 5,
    name: 'Sunita Desai',
    photo: 'https://randomuser.me/api/portraits/women/12.jpg',
    city: 'Mumbai',
    phone: '+91 98765 12005',
    specialty: 'Rental Agent',
    rating: 4.5,
    reviews: 166,
    listings: 47,
    experience: 8,
    languages: ['Hindi', 'Gujarati', 'English'],
    bio: 'Handles furnished and semi-furnished rentals across Andheri and Powai. Quick turnaround guaranteed.',
  },
  {
    id: 6,
    name: 'Vikram Nair',
    photo: 'https://randomuser.me/api/portraits/men/55.jpg',
    city: 'Bengaluru',
    phone: '+91 98765 12006',
    specialty: "Seller's Agent",
    rating: 4.9,
    reviews: 88,
    listings: 26,
    experience: 13,
    languages: ['Malayalam', 'English', 'Kannada'],
    bio: 'Premium villa and independent house sales in HSR Layout and Sarjapur Road. 13 years of trust.',
  },
  {
    id: 7,
    name: 'Pooja Verma',
    photo: 'https://randomuser.me/api/portraits/women/29.jpg',
    city: 'Pune',
    phone: '+91 98765 12007',
    specialty: "Buyer's Agent",
    rating: 4.8,
    reviews: 143,
    listings: 38,
    experience: 7,
    languages: ['Hindi', 'English'],
    bio: 'Helps first-time homebuyers navigate Hinjewadi and Baner with ease. Patient, thorough, reliable.',
  },
  {
    id: 8,
    name: 'Deepak Shetty',
    photo: 'https://randomuser.me/api/portraits/men/18.jpg',
    city: 'Mumbai',
    phone: '+91 98765 12008',
    specialty: "Buyer's Agent",
    rating: 4.7,
    reviews: 61,
    listings: 15,
    experience: 4,
    languages: ['Konkani', 'Hindi', 'English'],
    bio: 'Young, sharp agent focused on new launches in Thane and Navi Mumbai. Strong negotiator.',
  },
  {
    id: 9,
    name: 'Lakshmi Iyer',
    photo: 'https://randomuser.me/api/portraits/women/55.jpg',
    city: 'Hyderabad',
    phone: '+91 98765 12009',
    specialty: 'Rental Agent',
    rating: 4.6,
    reviews: 109,
    listings: 33,
    experience: 6,
    languages: ['Tamil', 'Telugu', 'English'],
    bio: 'Focused on expat and NRI rental needs in Jubilee Hills and Banjara Hills. Handles documentation end to end.',
  },
  {
    id: 10,
    name: 'Suresh Pillai',
    photo: 'https://randomuser.me/api/portraits/men/46.jpg',
    city: 'Bengaluru',
    phone: '+91 98765 12010',
    specialty: "Buyer's Agent",
    rating: 4.5,
    reviews: 57,
    listings: 22,
    experience: 5,
    languages: ['Malayalam', 'Kannada', 'English'],
    bio: 'Focuses on budget homes in Electronic City and BTM Layout. Great for young families.',
  },
  {
    id: 11,
    name: 'Anjali Kapoor',
    photo: 'https://randomuser.me/api/portraits/women/82.jpg',
    city: 'Pune',
    phone: '+91 98765 12011',
    specialty: "Seller's Agent",
    rating: 4.9,
    reviews: 178,
    listings: 44,
    experience: 10,
    languages: ['Hindi', 'English', 'Punjabi'],
    bio: 'Top-rated sellers agent in Aundh and Pashan. Gets your listing maximum eyeballs in minimum time.',
  },
  {
    id: 12,
    name: 'Mohammed Rafi',
    photo: 'https://randomuser.me/api/portraits/men/62.jpg',
    city: 'Hyderabad',
    phone: '+91 98765 12012',
    specialty: "Seller's Agent",
    rating: 4.7,
    reviews: 83,
    listings: 28,
    experience: 8,
    languages: ['Urdu', 'Telugu', 'Hindi', 'English'],
    bio: 'Specialist in Old City and Secunderabad heritage properties. Unique market knowledge, unmatched network.',
  },
  {
    id: 13,
    name: 'Rahul Malhotra',
    photo: 'https://randomuser.me/api/portraits/men/40.jpg',
    city: 'Delhi',
    phone: '+91 98765 12013',
    specialty: "Buyer's Agent",
    rating: 4.8,
    reviews: 132,
    listings: 31,
    experience: 9,
    languages: ['Hindi', 'English'],
    bio: 'Works extensively in South Delhi and Dwarka premium residential market.',
  },
  {
    id: 14,
    name: 'Simran Kaur',
    photo: 'https://randomuser.me/api/portraits/women/65.jpg',
    city: 'Delhi',
    phone: '+91 98765 12014',
    specialty: 'Rental Agent',
    rating: 4.6,
    reviews: 90,
    listings: 24,
    experience: 5,
    languages: ['Hindi', 'English', 'Punjabi'],
    bio: 'Helps professionals find rental apartments in Gurgaon and Noida.',
  },
  {
    id: 15,
    name: 'Karthik Raman',
    photo: 'https://randomuser.me/api/portraits/men/77.jpg',
    city: 'Chennai',
    phone: '+91 98765 12015',
    specialty: "Seller's Agent",
    rating: 4.7,
    reviews: 110,
    listings: 27,
    experience: 8,
    languages: ['Tamil', 'English'],
    bio: 'Known for fast property sales in OMR and Anna Nagar.',
  },
  {
    id: 16,
    name: 'Meera Subramanian',
    photo: 'https://randomuser.me/api/portraits/women/23.jpg',
    city: 'Chennai',
    phone: '+91 98765 12016',
    specialty: "Buyer's Agent",
    rating: 4.9,
    reviews: 154,
    listings: 41,
    experience: 10,
    languages: ['Tamil', 'English', 'Hindi'],
    bio: 'Specialises in family apartments and gated communities across Chennai.',
  },
  {
    id: 17,
    name: 'Amitava Sen',
    photo: 'https://randomuser.me/api/portraits/men/14.jpg',
    city: 'Kolkata',
    phone: '+91 98765 12017',
    specialty: 'Rental Agent',
    rating: 4.5,
    reviews: 72,
    listings: 18,
    experience: 6,
    languages: ['Bengali', 'Hindi', 'English'],
    bio: 'Focuses on affordable rentals in Salt Lake and New Town.',
  },
  {
    id: 18,
    name: 'Riya Banerjee',
    photo: 'https://randomuser.me/api/portraits/women/33.jpg',
    city: 'Kolkata',
    phone: '+91 98765 12018',
    specialty: "Seller's Agent",
    rating: 4.8,
    reviews: 121,
    listings: 29,
    experience: 7,
    languages: ['Bengali', 'English'],
    bio: 'Experienced in premium flats and resale properties in central Kolkata.',
  },
  {
    id: 19,
    name: 'Harsh Patel',
    photo: 'https://randomuser.me/api/portraits/men/85.jpg',
    city: 'Ahmedabad',
    phone: '+91 98765 12019',
    specialty: "Buyer's Agent",
    rating: 4.7,
    reviews: 98,
    listings: 26,
    experience: 8,
    languages: ['Gujarati', 'Hindi', 'English'],
    bio: 'Strong expertise in SG Highway and Satellite residential projects.',
  },
  {
    id: 20,
    name: 'Nisha Trivedi',
    photo: 'https://randomuser.me/api/portraits/women/91.jpg',
    city: 'Ahmedabad',
    phone: '+91 98765 12020',
    specialty: 'Rental Agent',
    rating: 4.6,
    reviews: 86,
    listings: 22,
    experience: 5,
    languages: ['Gujarati', 'English'],
    bio: 'Assists students and working professionals with rentals across Ahmedabad.',
  },
];

export default AGENTS;